import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
var filterRet0 = Coa.filterResponse(function (res) {
  if (res.ret !== 0) {
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
var actId;
export function setActId(_actId) {
  actId = _actId;
}
export function getActId() {
  return actId;
}
export function getEggInfo(id) {
  if (id) actId = id;
  return Coa(Coa.filterResponse(function (res) {
    return res.data;
  }), filterRet0).run('//vip.video.qq.com/fcgi-bin/comm_cgi?otype=json', {
    name: 'spp_fulishe_eggs_index',
    cmd: 2,
    actid: actId
  });
}
export function receiveEgg() {
  return Coa(Coa.filterResponse(function (res) {
    return res.data;
  }), filterRet0).run('//vip.video.qq.com/fcgi-bin/comm_cgi?otype=json', {
    name: 'fulishe_eggs_adapter',
    cmd: 1,
    actid: actId
  });
}
export function shakeEgg() {
  return Coa(Coa.filterResponse(function (res) {
    return res.data;
  }), filterRet0).run('//vip.video.qq.com/fcgi-bin/comm_cgi?otype=json', {
    name: 'spp_fulishe_eggs_collision',
    cmd: 65395,
    actid: actId
  });
}